import React, { useState, useEffect } from "react";
import AnalyzeListSearch from "./AnalyzeList_Search";
import AnalyzeListResult from "./AnalyzeList_Result";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import './TestPriority.scss'; 
import MapSidebar from "Components/Bars/MapSidebar";
import { CSSTransition } from 'react-transition-group'; // ES6
import { useSearchParams } from "react-router-dom";

const AnalyzeList = ({}) => {
    const [searchCondition, setsearchCondition] = useState([]);
    const [mapShow, setmapShow] = useState(false);
    const [bridgeData, setbridgeData] = useState([]);
    const [selectedBridge, setselectedBridge] = useState({});
    const [searchParams, setSearchParams] = useSearchParams(); // 
    useEffect(() => {
        // 讀取 URL 中的查詢參數，初始化 searchCondition
        const initialConditions = [];
        let index = 0;

        // 根據 index 讀取多組條件
        while (searchParams.get(`colName${index}`)) {
            const filter = searchParams.get(`filter${index}`);
            const colName = searchParams.get(`colName${index}`);
            const limit = searchParams.get(`limit${index}`);
            const value = searchParams.get(`value${index}`);
            const testCode = searchParams.get(`testCode${index}`);
            const frequency = searchParams.get(`frequency${index}`);
            const frequency1 = searchParams.get(`frequency1${index}`);
            const frequency2 = searchParams.get(`frequency2${index}`);

            initialConditions.push({
                filter,
                index,
                key: colName,
                colName,
                limit,
                value,
                testCode,
                frequency: frequency || null, 
                frequency1: frequency1 || null,
                frequency2: frequency2 || null,                                                                                                                                                                                                                                    
                
            });

            index++;
        }
        const testType = searchParams.get('testType') || 'A'; // 默認為 'A'
        initialConditions.push({ key: 'testType', value: testType });

        if (initialConditions.length > 0) {
            setsearchCondition(initialConditions);
        }

    }, [searchParams]);
    const onSearch = (newConditions) => {
        // 取得目前 URL 中的 testType
        const testType = searchParams.get('testType') || 'A'; // 默認為 'A'

        // 將 testType 加入到新的搜尋條件中
        const updatedConditions = [...newConditions, { key: 'testType', value: testType }];

        // 更新搜尋條件
        setsearchCondition(updatedConditions);

        // 更新 URL 中的搜尋參數，以保留 testType
        const updatedSearchParams = new URLSearchParams();
        updatedConditions.forEach((condition, index) => {
            if (condition.key && condition.value) {
                updatedSearchParams.set(`${condition.key}${index}`, condition.value);
            }
        });
        setSearchParams(updatedSearchParams);
    };
    
    const ToggleMapSideBar = () => {
        setmapShow((prev) => {
            const newMapShow = !prev;
            console.log("mapShow:", newMapShow);
            return newMapShow;
        });
    };

    return (
        <>
        <div className="DetailTestAnalyze-page p-2">
            <div className="navbar-container">
                <ol className="breadcrumb">
                    <li className="breadcrumb-item"><a href="./#">儀錶板</a></li>
                    <li className="breadcrumb-item active" aria-current="page">橋梁詳檢分析儀錶板</li>
                </ol>
            </div>
            <div className="l-grid-2row-ta__row2 o-content--rounded bg-white testPriority-form">
                <div className="position-absolute o-content--full">
                    <div className="left-container" style={{ width: mapShow ? "50%" : "100%" }}>
                    <AnalyzeListSearch setsearchCondition={setsearchCondition}  />
                        <AnalyzeListResult searchCondition={searchCondition} setbridgeData={setbridgeData} bridgeData={bridgeData} setselectedBridge={setselectedBridge} />
                    </div>
                </div>
                <CSSTransition in={mapShow} timeout={0} classNames="fademap">
                    <MapSidebar bridgeData={bridgeData} selectedBridge={selectedBridge} />
                </CSSTransition>
            </div>
        </div>
        </>
    );
}

export default AnalyzeList;